export default __webpack_public_path__ + "static/media/icon_warning.ad21c8e5.svg";